import React, { createContext } from "react";

import "./Partners.css";

function Partners() {
  return (
    <div className="partners">
      <div class="my-first-grid">
        <div class="partners-grid-item-1">1</div>
        <div class="partners-grid-item-2">2</div>
        <div class="partners-grid-item-3">3</div>
        <div class="partners-grid-item-4">4</div>
        <div class="partners-grid-item-5">5</div>
        {/* <div class="partners-grid-item-6">6</div>
        <div class="partners-grid-item-7">7</div>
        <div class="partners-grid-item-8">8</div>
        <div class="partners-grid-item-9">9</div> */}
      </div>
    </div>
  );
}

export default Partners;
